/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

"use client";

import { HeroSection } from "@/components/landing/hero-section";
import { isWaitlistMode, openWaitlist } from "@/lib/utils/waitlist-mode";
import { useNavigationWithProgress } from "@/hooks/utilities/use-navigation-with-progress";
import { useCallback } from "react";

export function HomeHeroWrapper() {
  const router = useNavigationWithProgress();

  const handleGetStarted = useCallback(() => {
    isWaitlistMode()
      ? openWaitlist()
      : (window.location.href = "/auth/sign-up");
  }, []);

  const handleWatchDemo = useCallback(() => {
    const features = document.getElementById("features");
    if (features) {
      features.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    router.push("/features");
  }, [router]);

  return (
    <HeroSection
      onGetStarted={handleGetStarted}
      onWatchDemo={handleWatchDemo}
    />
  );
}
